import { render, staticRenderFns } from "./LotteryEvent.vue?vue&type=template&id=0c76250a&scoped=true&"
import script from "./LotteryEvent.vue?vue&type=script&lang=js&"
export * from "./LotteryEvent.vue?vue&type=script&lang=js&"
import style0 from "./LotteryEvent.vue?vue&type=style&index=0&id=0c76250a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76250a",
  null
  
)

export default component.exports